import { DisplayOption, GeneralLookup } from "services/openapi";

export const getDisplayOptionLookup = (): GeneralLookup[] => {
    return [
        {
            id: DisplayOption.TWO_PER_ROW,
            name: DisplayOption.TWO_PER_ROW.replace(/([a-z])([A-Z])/g, '$1 $2'),
            code: DisplayOption.TWO_PER_ROW,
        },
        {
            id: DisplayOption.FULL_PAGE,
            name: DisplayOption.FULL_PAGE.replace(/([a-z])([A-Z])/g, '$1 $2'),
            code: DisplayOption.FULL_PAGE,
        },
    ];
};

/**
 * Formats DisplayOption enum value to readable string
 * @param value The enum value to format
 * @returns Formatted string with spaces
 */
export const formatDisplayOption = (value?: string): string => {
    if (!value) return '';
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
};